//import libraries
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Resolve } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';

//import constants
import { AppSettings } from '../constants/app-settings';
import { AppBackRoutes } from '../constants/app-back-routes';

//import language
import { SupportTicketListLang, SupportTicketCreateLang, SupportTicketViewLang } from '../languages/SupportTicket.Lang';

//import services
import { GeneralService } from '../services/general.service';

@Injectable()

export class AdminTicketService{

    constructor(
        private http: HttpClient,
        private generalService: GeneralService,
    ) { }

    createTicket(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.ticketCreate;
        return this.http.post<any>(url, data);
    }

    replyTicket(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.adminticketReply;
        return this.http.post<any>(url, data);
    }

    viewTicket(id: any) {

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.ticketView + '/' + id;
        return this.http.get<any>(url);

    }

    closeTicket(id: any) {

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.adminticketClose + '/' + id;
        return this.http.get<any>(url);

    }

    getList(userType){

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.adminticketList+"/"+userType;
        return this.http.get<any>(url);

    }

    getCategories(){

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.ticketCategories;
        return this.http.get<any>(url);

    }

    listLang(details: any) {

        if (!details) return;

        let instance = new SupportTicketListLang(details.data.language);
        return instance.lang();

    }

    createLang(details: any) {

        if (!details) return;

        let instance = new SupportTicketCreateLang(details.language);
        return instance.lang();

    }

    viewLang(details: any) {

        if (!details) return;

        let instance = new SupportTicketViewLang(details.language);
        return instance.lang();

    }


    getMailConfigList() {

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.adminticketList;
        return this.http.get<any>(url);

        // let data1 = { 'mail_wizard': '' };
        // let url = AppSettings.API_ENDPOINT + AppBackRoutes.mailConfigList;
        // return this.http.post<any>(url, data1);
    }

}